import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const BlockedSendersOption: LazyOption = createLazyOption(
    {
        key: 'blockedSenders',
        titleStringKey: 'optionTitle_blockedSenders',
        searchTermsStringKey: 'optionSearchTerms_blockedSenders',
        allowedOptionKeys: ['BlockSenders'],
        isHidden: () => {
            return isFeatureEnabled('tri-spamV2SenderDomain') || IsShadowMailboxUser();
        },
    },
    lazyFullModule,
    m => m.default
);
export default BlockedSendersOption;
